import axios from "axios";
import { formatDate } from "utils/date";
import { buildDseQuery } from "utils/queryUtils";

export const findSmsLogs = (headers, params) => {
    const val = {
        first: params.first,
        rows: params.rows,
        page: params.page,
        sortField: params.sortField,
        sortOrder: params.sortOrder,
        filters: {
            phoneNumber: { ...params.filters.phoneNumber },
            status: { ...params.filters.status },
        },
    };
    let query = buildDseQuery(val, [""]);

    if (params.filters.fromDate.value) {
        query += `${val.filters.phoneNumber.value || val.filters.status.value ? ";" : ""}createdDate=ge=${formatDate(params.filters.fromDate.value)}`;
    }
    if (params.filters.toDate.value) {
        const toDateVal = new Date(new Date(params?.filters.toDate.value).setDate(new Date(params?.filters.toDate.value).getDate() + 1));
        query += `;createdDate=le=${formatDate(toDateVal)}`;
    }
    return axios.get(`${process.env.REACT_APP_ACM_API_URL}/sms-logs${query}`, {
        headers,
    });
};
